import React, { useEffect, useState, Component } from 'react';
import { HeartCrack, CheckCircle2, ShieldCheck, ChevronDown, ChevronUp, ArrowRight, Gift, Clock, Star, X } from 'lucide-react';
const CHECKOUT_URL = 'https://colorpack.online/cart/47908641669259:1?storefront=true';
// --- Components ---
const CTAButton = ({
  text = 'SÍ, QUIERO RECUPERAR MI TRANQUILIDAD',
  className = ''
}) => <a href={CHECKOUT_URL} className={`block w-full max-w-md mx-auto bg-gradient-to-r from-rose-500 to-pink-600 hover:from-rose-600 hover:to-pink-700 text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-[0_8px_20px_rgba(225,29,72,0.4)] hover:shadow-[0_12px_25px_rgba(225,29,72,0.6)] transform hover:-translate-y-1 transition-all duration-300 text-center uppercase tracking-wide border-b-4 border-rose-700 ${className}`} data-id="element-0">
    {text}
    <ArrowRight className="inline-block ml-2 w-6 h-6 animate-pulse" data-id="element-1" />
  </a>;
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 17,
    seconds: 33
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          return {
            hours: 0,
            minutes: 17,
            seconds: 33
          }; // Reset
        }
        let h = prev.hours;
        let m = prev.minutes;
        let s = prev.seconds - 1;
        if (s < 0) {
          s = 59;
          m -= 1;
        }
        if (m < 0) {
          m = 59;
          h -= 1;
        }
        return {
          hours: h,
          minutes: m,
          seconds: s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex flex-col items-center justify-center my-6" data-id="element-2">
      <div className="text-rose-600 font-bold mb-2 uppercase tracking-widest text-sm" data-id="element-3">
        La oferta expira en:
      </div>
      <div className="flex gap-4 text-center" data-id="element-4">
        <div className="flex flex-col" data-id="element-5">
          <div className="bg-slate-900 text-white text-3xl md:text-4xl font-black py-3 px-4 rounded-lg shadow-inner" data-id="element-6">
            {pad(timeLeft.hours)}
          </div>
          <span className="text-xs font-semibold mt-1 text-slate-600 uppercase" data-id="element-7">
            Horas
          </span>
        </div>
        <div className="text-3xl md:text-4xl font-black text-slate-900 py-2" data-id="element-8">
          :
        </div>
        <div className="flex flex-col" data-id="element-9">
          <div className="bg-slate-900 text-white text-3xl md:text-4xl font-black py-3 px-4 rounded-lg shadow-inner" data-id="element-10">
            {pad(timeLeft.minutes)}
          </div>
          <span className="text-xs font-semibold mt-1 text-slate-600 uppercase" data-id="element-11">
            Minutos
          </span>
        </div>
        <div className="text-3xl md:text-4xl font-black text-slate-900 py-2" data-id="element-12">
          :
        </div>
        <div className="flex flex-col" data-id="element-13">
          <div className="bg-rose-600 text-white text-3xl md:text-4xl font-black py-3 px-4 rounded-lg shadow-inner" data-id="element-14">
            {pad(timeLeft.seconds)}
          </div>
          <span className="text-xs font-semibold mt-1 text-rose-600 uppercase" data-id="element-15">
            Segundos
          </span>
        </div>
      </div>
    </div>;
};
const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    country: '',
    time: ''
  });
  const names = ['María', 'Laura', 'Sofía', 'Camila', 'Valentina', 'Lucía', 'Martina', 'Daniela', 'Valeria', 'Andrea'];
  const countries = ['México', 'Colombia', 'España', 'Argentina', 'Chile', 'Perú', 'Ecuador', 'Estados Unidos'];
  const times = ['hace 2 minutos', 'hace 5 minutos', 'hace 12 minutos', 'hace 1 hora', 'justo ahora'];
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCountry = countries[Math.floor(Math.random() * countries.length)];
      const randomTime = times[Math.floor(Math.random() * times.length)];
      setData({
        name: randomName,
        country: randomCountry,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring
    const interval = setInterval(() => {
      showPopup();
    }, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 md:bottom-8 md:left-8 bg-white rounded-lg shadow-2xl p-4 flex items-center gap-4 z-50 animate-fade-in-up border-l-4 border-rose-500 max-w-sm" data-id="element-16">
      <div className="bg-rose-100 p-2 rounded-full" data-id="element-17">
        <CheckCircle2 className="w-6 h-6 text-rose-600" data-id="element-18" />
      </div>
      <div data-id="element-19">
        <p className="text-sm text-slate-800" data-id="element-20">
          <span className="font-bold" data-id="element-21">{data.name}</span> de {data.country}
        </p>
        <p className="text-xs text-slate-500" data-id="element-22">
          Compró Proyecto Renacer™ {data.time}
        </p>
      </div>
      <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-slate-400 hover:text-slate-600" data-id="element-23">
        <X className="w-4 h-4" data-id="element-24" />
      </button>
    </div>;
};
const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show once the user scrolls past the first CTA (roughly one viewport height)
      setIsVisible(window.scrollY > window.innerHeight * 0.9);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 inset-x-0 z-40 px-4 flex justify-center pointer-events-none animate-fade-in-up" data-id="element-25">
      <a href={CHECKOUT_URL} className="pointer-events-auto w-full max-w-md bg-gradient-to-r from-rose-500 to-pink-600 hover:from-rose-600 hover:to-pink-700 text-white font-bold text-base md:text-lg py-4 px-6 rounded-full shadow-[0_10px_30px_rgba(225,29,72,0.5)] transform hover:-translate-y-0.5 transition-all duration-300 text-center uppercase tracking-wide border-b-4 border-rose-700 flex items-center justify-center gap-2" data-id="element-26">
        Quiero acceder por $12.99
        <ArrowRight className="w-5 h-5" data-id="element-27" />
      </a>
    </div>;
};
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-slate-200 py-4" data-id="element-28">
      <button className="flex justify-between items-center w-full text-left font-bold text-slate-800 hover:text-rose-600 transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-29">
        <span className="pr-4" data-id="element-30">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 flex-shrink-0" data-id="element-31" /> : <ChevronDown className="w-5 h-5 flex-shrink-0" data-id="element-32" />}
      </button>
      {isOpen && <div className="mt-3 text-slate-600 leading-relaxed animate-fade-in" data-id="element-33">
          {answer}
        </div>}
    </div>;
};
export function App() {
  return <div className="font-sans text-slate-800 bg-slate-50 selection:bg-rose-200 selection:text-rose-900" data-id="element-34">
      {/* SECCIÓN 1: HERO */}
      <section className="relative bg-gradient-to-b from-[#fdf2f8] to-white pt-12 pb-20 px-4 overflow-hidden" data-id="element-35">
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-36">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#4b2e5e] leading-tight mb-6 tracking-tight" data-id="element-37">
            Recupera tu tranquilidad en solo{' '}
            <span className="text-rose-600 underline decoration-rose-300 decoration-4 underline-offset-4" data-id="element-38">
              21 días
            </span>
            , sin fingir que ya olvidaste a tu ex
          </h1>

          <div className="my-10 relative" data-id="element-39">
            <div className="absolute inset-0 bg-rose-200 blur-3xl opacity-30 rounded-full" data-id="element-40"></div>
            <a href={CHECKOUT_URL} data-id="element-41">
              <img src="https://cdn.magicpatterns.com/uploads/dW74okDo9CrcGRT3xmANNT/21_dias_mockup_principal.png" alt="Proyecto Renacer - Protocolo 21 Días" className="w-full max-w-lg mx-auto relative z-10 drop-shadow-2xl hover:scale-105 transition-transform duration-500 cursor-pointer" data-id="element-42" />
            </a>
          </div>

          <p className="text-xl md:text-2xl text-slate-700 font-medium mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-43">
            El sistema guiado que te ayuda a dejar de vivir atrapada en una
            ruptura, recuperar el control de tus emociones y volver a elegirte a
            ti misma dedicando solo{' '}
            <strong className="bg-rose-100 text-rose-800 px-2 py-1 rounded" data-id="element-44">
              10 minutos al día
            </strong>
            .
          </p>

          <div className="bg-white p-8 rounded-2xl shadow-xl border border-rose-100 max-w-3xl mx-auto text-left mb-10" data-id="element-45">
            <p className="text-lg mb-4" data-id="element-46">
              Quizá hoy sientas que cada mañana empieza igual.
            </p>
            <p className="text-lg mb-4" data-id="element-47">
              Abres los ojos y él ya está en tu mente.
            </p>
            <p className="text-lg mb-4" data-id="element-48">
              Revisas el teléfono esperando un mensaje que nunca llega.
            </p>
            <p className="text-lg mb-4" data-id="element-49">
              Intentas distraerte, pero cualquier canción, lugar o recuerdo
              vuelve a romper tu calma.
            </p>
            <p className="text-lg font-bold text-rose-700 mb-4" data-id="element-50">
              No necesitas escuchar otra vez que "el tiempo lo cura todo".
            </p>
            <p className="text-lg font-bold text-[#4b2e5e]" data-id="element-51">
              Lo que necesitas es un camino claro.
            </p>
          </div>

          <CTAButton text="SÍ, QUIERO EMPEZAR MI PROCESO HOY" data-id="element-52" />
        </div>
      </section>

      {/* SECCIÓN 2: IDENTIFICACIÓN (PAIN) */}
      <section className="py-20 px-4 bg-[#4b2e5e] text-white" data-id="element-53">
        <div className="max-w-4xl mx-auto" data-id="element-54">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-rose-200" data-id="element-55">
            ¿Te identificas con alguna de estas situaciones?
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-56">
            {['Sientes que piensas en tu ex prácticamente todo el día.', 'Revisas una y otra vez sus redes sociales esperando encontrar alguna señal.', 'Te preguntas constantemente qué hiciste mal.', 'Lees conversaciones antiguas intentando entender por qué terminó todo.', 'Hay días en los que no tienes ganas de hacer absolutamente nada.', 'Intentas distraerte, pero el dolor siempre termina regresando.', 'Sientes ansiedad cuando imaginas que esa persona ya siguió adelante.', 'Has escuchado consejos de amigos, pero ninguno logra ayudarte realmente.', 'Quieres dejar de sufrir, pero no sabes por dónde empezar.'].map((item, i) => <div key={i} className="flex items-start gap-4 bg-white/10 p-4 rounded-xl backdrop-blur-sm" data-id="element-57">
                <HeartCrack className="w-6 h-6 text-rose-400 flex-shrink-0 mt-1" data-id="element-58" />
                <p className="text-lg font-medium" data-id="element-59">{item}</p>
              </div>)}
          </div>

          <div className="text-center bg-rose-600 p-8 rounded-2xl shadow-2xl" data-id="element-60">
            <p className="text-2xl font-bold mb-4" data-id="element-61">
              Si respondiste "sí" a varias de ellas, este sistema fue creado
              para ti.
            </p>
            <p className="text-xl mb-6" data-id="element-62">
              La realidad es que no estás fallando. Simplemente nadie te enseñó
              cómo atravesar una ruptura de manera saludable.
            </p>
            <p className="text-xl font-black text-rose-100" data-id="element-63">
              Y eso es exactamente lo que aprenderás dentro de Proyecto
              Renacer™.
            </p>
          </div>
        </div>
      </section>

      {/* SECCIÓN 3: TRANSFORMACIÓN */}
      <section className="py-20 px-4 bg-white" data-id="element-64">
        <div className="max-w-4xl mx-auto" data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-6 text-[#4b2e5e]" data-id="element-66">
            Así cambiará tu vida cuando completes Proyecto Renacer™
          </h2>
          <p className="text-xl text-center text-slate-600 mb-12 max-w-2xl mx-auto" data-id="element-67">
            Este no es un libro para leer y guardar en un cajón. Es un proceso
            diseñado para ayudarte a vivir una transformación real.
          </p>

          <div className="space-y-4 mb-12" data-id="element-68">
            {['Comprender y gestionar mejor tus emociones sin sentirte desbordada.', 'Reducir el tiempo que pasas pensando obsesivamente en tu ex.', 'Recuperar la seguridad y la confianza en ti misma.', 'Dejar de idealizar una relación que ya terminó.', 'Aprender a poner límites emocionales saludables.', 'Crear hábitos que fortalezcan tu bienestar todos los días.', 'Volver a disfrutar de tu tiempo sin depender emocionalmente de otra persona.', 'Mirar hacia el futuro con esperanza en lugar de miedo.', 'Construir una relación mucho más sana contigo misma.'].map((item, i) => <div key={i} className="flex items-center gap-4 p-4 hover:bg-rose-50 rounded-lg transition-colors border border-transparent hover:border-rose-100" data-id="element-69">
                <div className="bg-rose-100 p-2 rounded-full" data-id="element-70">
                  <CheckCircle2 className="w-6 h-6 text-rose-600" data-id="element-71" />
                </div>
                <p className="text-lg font-medium text-slate-700" data-id="element-72">{item}</p>
              </div>)}
          </div>

          <div className="text-center mb-12" data-id="element-73">
            <p className="text-2xl font-bold text-slate-800 mb-2" data-id="element-74">
              Porque la verdadera meta nunca fue olvidar a alguien.
            </p>
            <p className="text-3xl font-black text-rose-600" data-id="element-75">
              La verdadera meta es volver a encontrarte contigo.
            </p>
          </div>

          <CTAButton text="QUIERO VOLVER A ENCONTRARME" data-id="element-76" />
        </div>
      </section>

      {/* TESTIMONIOS */}
      <section className="py-20 px-4 bg-slate-100" data-id="element-77">
        <div className="max-w-6xl mx-auto" data-id="element-78">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-[#4b2e5e]" data-id="element-79">
            Mujeres que ya recuperaron su paz
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-80">
            {[{
            name: 'Carolina M.',
            age: '28 años',
            text: 'Pensé que nunca iba a dejar de llorar. Este workbook me dio la estructura que mi mente necesitaba cuando todo era un caos. Hoy, 3 semanas después, me siento dueña de mi vida otra vez.',
            img: 'https://i.pravatar.cc/150?img=47'
          }, {
            name: 'Valentina R.',
            age: '34 años',
            text: 'Había intentado de todo, pero seguía estancada revisando sus redes. El manual de emergencia y los ejercicios diarios literalmente me salvaron de volver a escribirle. Vale cada centavo.',
            img: 'https://i.pravatar.cc/150?img=43'
          }, {
            name: 'Andrea S.',
            age: '31 años',
            text: 'No es solo un libro, es como tener a alguien sosteniéndote la mano todos los días. Las cartas que nunca enviarás me ayudaron a soltar un peso que llevaba cargando meses.',
            img: 'https://i.pravatar.cc/150?img=49'
          }, {
            name: 'Daniela P.',
            age: '26 años',
            text: 'Lo compré una noche en la que no dejaba de llorar. En la primera semana ya había dejado de revisar sus redes cada cinco minutos. Nunca pensé que algo tan simple me devolvería la calma.',
            img: 'https://i.pravatar.cc/150?img=45'
          }, {
            name: 'Gabriela T.',
            age: '38 años',
            text: 'Llevaba meses estancada y sintiéndome culpable por no "superarlo ya". El checklist de contacto cero y las afirmaciones cambiaron mi forma de hablarme a mí misma. Hoy vuelvo a sonreír.',
            img: 'https://i.pravatar.cc/150?img=44'
          }].map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-lg border-t-4 border-rose-400" data-id="element-81">
                <div className="flex text-yellow-400 mb-4" data-id="element-82">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-83" />)}
                </div>
                <p className="text-slate-600 italic mb-6" data-id="element-84">"{t.text}"</p>
                <div className="flex items-center gap-4" data-id="element-85">
                  <img src={t.img} alt={t.name} className="w-12 h-12 rounded-full object-cover" data-id="element-86" />
                  <div data-id="element-87">
                    <p className="font-bold text-slate-800" data-id="element-88">{t.name}</p>
                    <p className="text-sm text-slate-500" data-id="element-89">{t.age}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECCIÓN 4: OFERTA (STACK) */}
      <section className="py-20 px-4 bg-gradient-to-b from-[#4b2e5e] to-slate-900 text-white" id="oferta" data-id="element-90">
        <div className="max-w-5xl mx-auto" data-id="element-91">
          <div className="text-center mb-16" data-id="element-92">
            <h2 className="text-4xl md:text-5xl font-black mb-4 text-rose-300" data-id="element-93">
              Esto es todo lo que recibirás hoy
            </h2>
            <p className="text-xl text-slate-300" data-id="element-94">
              Sistema Completo de Recuperación Emocional
            </p>
          </div>

          {/* Main Product */}
          <div className="bg-white text-slate-800 rounded-3xl overflow-hidden shadow-2xl mb-12 flex flex-col md:flex-row items-center" data-id="element-95">
            <div className="md:w-1/2 p-8 text-center bg-rose-50" data-id="element-96">
              <a href={CHECKOUT_URL} data-id="element-97">
                <img src="https://cdn.magicpatterns.com/uploads/dW74okDo9CrcGRT3xmANNT/21_dias_mockup_principal.png" alt="Protocolo 21 Días" className="w-full max-w-sm mx-auto drop-shadow-xl hover:scale-105 transition-transform cursor-pointer" data-id="element-98" />
              </a>
            </div>
            <div className="md:w-1/2 p-8 md:p-12" data-id="element-99">
              <div className="inline-block bg-rose-600 text-white font-bold px-3 py-1 rounded-full text-sm mb-4 uppercase tracking-wide" data-id="element-100">
                Producto Principal
              </div>
              <h3 className="text-3xl font-black text-[#4b2e5e] mb-4" data-id="element-101">
                Protocolo 21 Días para Superar a Tu Ex
              </h3>
              <p className="text-lg text-slate-600 mb-6" data-id="element-102">
                Workbook terapéutico de 46 páginas con ejercicios guiados para
                acompañarte durante 21 días.
              </p>
              <p className="text-xl font-bold text-slate-400 line-through" data-id="element-103">
                Valor: USD 49
              </p>
            </div>
          </div>

          <h3 className="text-3xl font-black text-center mb-8 text-white" data-id="element-104">
            Además, si ordenas hoy, te llevas estos{' '}
            <span className="text-rose-400" data-id="element-105">5 BONOS GRATIS</span>
          </h3>

          {/* Bonuses */}
          <div className="space-y-8 mb-16" data-id="element-106">
            {/* Bono 1 */}
            <div className="bg-slate-800 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center gap-8 border border-slate-700" data-id="element-107">
              <div className="md:w-1/3" data-id="element-108">
                <a href={CHECKOUT_URL} data-id="element-109">
                  <img src="https://cdn.magicpatterns.com/uploads/2UGGzMjccmGXCBjoZKciyg/mockup_1_21.png" alt="Cartas que Nunca Enviarás" className="w-full rounded-lg shadow-lg hover:scale-105 transition-transform cursor-pointer" data-id="element-110" />
                </a>
              </div>
              <div className="md:w-2/3" data-id="element-111">
                <div className="flex items-center gap-2 text-rose-400 font-bold mb-2" data-id="element-112">
                  <Gift className="w-5 h-5" data-id="element-113" /> BONO #1 (GRATIS HOY)
                </div>
                <h4 className="text-2xl font-bold mb-3" data-id="element-114">
                  Cartas que Nunca Enviarás
                </h4>
                <p className="text-slate-300 mb-4" data-id="element-115">
                  Cinco ejercicios de escritura terapéutica para liberar
                  emociones que aún permanecen dentro de ti.
                </p>
                <p className="text-slate-400 line-through" data-id="element-116">Valor: USD 19</p>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="bg-slate-800 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center gap-8 border border-slate-700" data-id="element-117">
              <div className="md:w-1/3" data-id="element-118">
                <a href={CHECKOUT_URL} data-id="element-119">
                  <img src="https://cdn.magicpatterns.com/uploads/9wggk9YHKiG9v5XNqTqZNr/mockup_2_21.png" alt="Diario de Sanación" className="w-full rounded-lg shadow-lg hover:scale-105 transition-transform cursor-pointer" data-id="element-120" />
                </a>
              </div>
              <div className="md:w-2/3" data-id="element-121">
                <div className="flex items-center gap-2 text-rose-400 font-bold mb-2" data-id="element-122">
                  <Gift className="w-5 h-5" data-id="element-123" /> BONO #2 (GRATIS HOY)
                </div>
                <h4 className="text-2xl font-bold mb-3" data-id="element-124">Diario de Sanación</h4>
                <p className="text-slate-300 mb-4" data-id="element-125">
                  Journal guiado de 90 días para seguir fortaleciendo tu
                  bienestar emocional.
                </p>
                <p className="text-slate-400 line-through" data-id="element-126">Valor: USD 29</p>
              </div>
            </div>

            {/* Bono 3 */}
            <div className="bg-slate-800 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center gap-8 border border-slate-700" data-id="element-127">
              <div className="md:w-1/3" data-id="element-128">
                <a href={CHECKOUT_URL} data-id="element-129">
                  <img src="https://cdn.magicpatterns.com/uploads/udqPwk7Cbjzb33ET74UVeB/mockup_3_21.png" alt="Manual de Emergencia" className="w-full rounded-lg shadow-lg hover:scale-105 transition-transform cursor-pointer" data-id="element-130" />
                </a>
              </div>
              <div className="md:w-2/3" data-id="element-131">
                <div className="flex items-center gap-2 text-rose-400 font-bold mb-2" data-id="element-132">
                  <Gift className="w-5 h-5" data-id="element-133" /> BONO #3 (GRATIS HOY)
                </div>
                <h4 className="text-2xl font-bold mb-3" data-id="element-134">
                  Manual de Emergencia
                </h4>
                <p className="text-slate-300 mb-4" data-id="element-135">
                  Qué hacer exactamente cuando: Quieres escribirle, lo extrañas,
                  sueñas con él, revisas sus redes o sientes que recaíste.
                </p>
                <p className="text-slate-400 line-through" data-id="element-136">Valor: USD 27</p>
              </div>
            </div>

            {/* Bono 4 */}
            <div className="bg-slate-800 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center gap-8 border border-slate-700" data-id="element-137">
              <div className="md:w-1/3" data-id="element-138">
                <a href={CHECKOUT_URL} data-id="element-139">
                  <img src="https://cdn.magicpatterns.com/uploads/htX2yZqjwv5gF8gRbw52gw/mockup_4_21.png" alt="50 Afirmaciones" className="w-full rounded-lg shadow-lg hover:scale-105 transition-transform cursor-pointer" data-id="element-140" />
                </a>
              </div>
              <div className="md:w-2/3" data-id="element-141">
                <div className="flex items-center gap-2 text-rose-400 font-bold mb-2" data-id="element-142">
                  <Gift className="w-5 h-5" data-id="element-143" /> BONO #4 (GRATIS HOY)
                </div>
                <h4 className="text-2xl font-bold mb-3" data-id="element-144">
                  50 Afirmaciones para Sanar una Ruptura
                </h4>
                <p className="text-slate-300 mb-4" data-id="element-145">
                  Tarjetas listas para imprimir o utilizar desde tu celular.
                </p>
                <p className="text-slate-400 line-through" data-id="element-146">Valor: USD 15</p>
              </div>
            </div>

            {/* Bono 5 */}
            <div className="bg-slate-800 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center gap-8 border border-slate-700" data-id="element-147">
              <div className="md:w-1/3" data-id="element-148">
                <a href={CHECKOUT_URL} data-id="element-149">
                  <img src="https://cdn.magicpatterns.com/uploads/cziGCa591NtDFyBhaigjvA/mockup_5_21.png" alt="Checklist Contacto Cero" className="w-full rounded-lg shadow-lg hover:scale-105 transition-transform cursor-pointer" data-id="element-150" />
                </a>
              </div>
              <div className="md:w-2/3" data-id="element-151">
                <div className="flex items-center gap-2 text-rose-400 font-bold mb-2" data-id="element-152">
                  <Gift className="w-5 h-5" data-id="element-153" /> BONO #5 (GRATIS HOY)
                </div>
                <h4 className="text-2xl font-bold mb-3" data-id="element-154">
                  Checklist Contacto Cero
                </h4>
                <p className="text-slate-300 mb-4" data-id="element-155">
                  Una guía práctica para mantener distancia emocional y proteger
                  tu proceso de recuperación.
                </p>
                <p className="text-slate-400 line-through" data-id="element-156">Valor: USD 15</p>
              </div>
            </div>
          </div>

          {/* Pricing Box */}
          <div className="bg-white text-slate-900 rounded-3xl p-8 md:p-12 text-center max-w-3xl mx-auto shadow-[0_0_50px_rgba(225,29,72,0.3)] border-4 border-rose-500 relative" data-id="element-157">
            <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-rose-600 text-white font-black px-6 py-2 rounded-full shadow-lg uppercase tracking-wider" data-id="element-158">
              Oferta Especial
            </div>

            <p className="text-xl font-bold text-slate-500 mb-2" data-id="element-159">
              Valor total del sistema:{' '}
              <span className="line-through" data-id="element-160">USD 154</span>
            </p>
            <p className="text-2xl font-medium mb-4" data-id="element-161">
              Hoy puedes obtener acceso inmediato por solo
            </p>
            <div className="text-6xl md:text-8xl font-black text-[#4b2e5e] mb-6 tracking-tighter" data-id="element-162">
              <span className="text-4xl align-top" data-id="element-163">$</span>12.99
            </div>

            <div className="flex justify-center gap-4 mb-8 text-sm font-bold text-slate-600 uppercase" data-id="element-164">
              <span className="flex items-center gap-1" data-id="element-165">
                <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-166" /> Pago único
              </span>
              <span className="flex items-center gap-1" data-id="element-167">
                <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-168" /> Sin
                mensualidades
              </span>
              <span className="flex items-center gap-1" data-id="element-169">
                <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-170" /> Acceso
                inmediato
              </span>
            </div>

            <CTAButton text="SÍ, QUIERO TODO POR $12.99" className="text-xl md:text-2xl py-5" data-id="element-171" />

            <CountdownTimer data-id="element-172" />

            <div className="mt-6 flex items-center justify-center gap-2 text-slate-500 text-sm" data-id="element-173">
              <ShieldCheck className="w-5 h-5" data-id="element-174" /> Pago 100% Seguro y Encriptado
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 5: GARANTÍA */}
      <section className="py-20 px-4 bg-rose-50" data-id="element-175">
        <div className="max-w-3xl mx-auto text-center" data-id="element-176">
          <ShieldCheck className="w-24 h-24 text-rose-500 mx-auto mb-6" data-id="element-177" />
          <h2 className="text-3xl md:text-4xl font-black text-[#4b2e5e] mb-6" data-id="element-178">
            Tu compra está 100% protegida
          </h2>
          <div className="text-lg text-slate-700 space-y-4 mb-10" data-id="element-179">
            <p data-id="element-180">
              Entiendo que comenzar un proceso de recuperación emocional es una
              decisión importante. Por eso quiero que hagas tu compra con
              tranquilidad.
            </p>
            <p className="font-bold" data-id="element-181">
              Si durante los primeros 7 días consideras que Proyecto Renacer™
              no era lo que esperabas, podrás solicitar la devolución de tu
              dinero.
            </p>
            <p data-id="element-182">Sin preguntas complicadas. Sin procesos interminables.</p>
            <p data-id="element-183">
              Mi objetivo no es venderte un ebook. Mi objetivo es que tengas
              acceso a herramientas que realmente puedan acompañarte en este
              momento de tu vida.
            </p>
            <p className="text-xl font-black text-rose-600 mt-6" data-id="element-184">
              Lo único que te pido es que te des la oportunidad de empezar.
            </p>
          </div>
          <CTAButton text="EMPEZAR MI PROCESO SIN RIESGO" data-id="element-185" />
        </div>
      </section>

      {/* SECCIÓN 6: FAQ */}
      <section className="py-20 px-4 bg-white" data-id="element-186">
        <div className="max-w-3xl mx-auto" data-id="element-187">
          <h2 className="text-3xl md:text-4xl font-black text-center text-[#4b2e5e] mb-12" data-id="element-188">
            Preguntas Frecuentes
          </h2>

          <div className="bg-white rounded-2xl shadow-xl border border-slate-100 p-6 md:p-8" data-id="element-189">
            <FAQItem question="¿Este programa reemplaza una terapia psicológica?" answer="No. Proyecto Renacer™ es un recurso educativo y de desarrollo personal. Si estás atravesando una situación emocional muy intensa o una crisis de salud mental, lo más recomendable es buscar apoyo de un profesional de la salud mental." data-id="element-190" />
            <FAQItem question="¿Cuánto tiempo debo dedicarle cada día?" answer="Aproximadamente entre 10 y 15 minutos diarios. El objetivo es que puedas avanzar incluso si tienes poco tiempo." data-id="element-191" />
            <FAQItem question="¿Recibiré el material inmediatamente?" answer="Sí. Una vez confirmado tu pago recibirás acceso inmediato para descargar todo el contenido." data-id="element-192" />
            <FAQItem question="¿Qué pasa si terminé mi relación hace varios meses?" answer="El protocolo puede ayudarte tanto si la ruptura es reciente como si llevas tiempo sintiéndote emocionalmente estancada." data-id="element-193" />
            <FAQItem question="¿Funciona si todavía sigo hablando con mi ex?" answer="Sí. Muchos ejercicios están diseñados precisamente para ayudarte a recuperar claridad emocional, independientemente del nivel de contacto que todavía exista." data-id="element-194" />
            <FAQItem question="¿Necesito conocimientos previos?" answer="No. Todo el sistema está diseñado para acompañarte paso a paso desde el primer día. Solo necesitas el compromiso de dedicar unos minutos diarios a tu proceso." data-id="element-195" />
            <FAQItem question="¿En qué formato recibiré el material?" answer="Recibirás todos los recursos en formato digital (PDF), para que puedas utilizarlos desde tu computadora, tablet o teléfono, o imprimirlos si prefieres escribir a mano." data-id="element-196" />
          </div>

          <div className="mt-16 text-center" data-id="element-197">
            <CTAButton text="QUIERO ACCEDER AHORA" data-id="element-198" />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-400 py-8 text-center text-sm" data-id="element-199">
        <div className="max-w-4xl mx-auto px-4" data-id="element-200">
          <p className="mb-2" data-id="element-201">
            © {new Date().getFullYear()} Proyecto Renacer™. Todos los derechos
            reservados.
          </p>
          <p className="text-xs" data-id="element-202">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      {/* Popup Notification */}
      <PurchasePopup data-id="element-203" />

      {/* Floating CTA (appears after the first CTA) */}
      <FloatingCTA data-id="element-204" />
    </div>;
}